/**
 * Pre-compiled pt-BR messages for DataTable
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  comfortable: `Confortável`,
  comfortableAriaLabel: `Seção confortável`,
  compact: `Compacto`,
  compactAriaLabel: `Seção compacta`,
  dataTable: `Tabela de dados`,
  dataTableBody: `Corpo da tabela de dados`,
  dataTableHeader: `Cabeçalho da tabela de dados`,
  expandRows: `Expandir linhas`,
  fullText: `Texto completo`,
  fullTextAriaLabel: `Seção de texto completo`,
  hiddenColumns: `Colunas ocultas`,
  hiddenColumnsAriaLabel: `Lista de colunas ocultas`,
  hideColumn: `Ocultar coluna`,
  layoutSettings: `Configurações de layout`,
  layoutSettingsAriaLabel: `Seção de configurações de layout`,
  noHiddenColumns: `Sem colunas ocultas`,
  pinRows: `Fixar linhas`,
  reset: `Redefinir colunas`,
  resizeColumn: `Redimensionar colunas`,
  rowDensity: `Densidade da linha`,
  rowDensityAriaLabel: `Seção de densidade da linha`,
  searchHiddenColumns: `Buscar...`,
  selectRow: `Selecionar linha`,
  settings: `Configurações da tabela`,
  settingsTabsAriaLabel: `Guias de Configurações`,
  textPreviews: `Pré-visualizações de texto`,
  textPreviewsAriaLabel: `Seção de pré-visualizações de texto`,
  textVisibility: `Visibilidade do texto`,
  textVisibilityAriaLabel: `Seção de visibilidade do texto`,
  visibleColumns: `Colunas visíveis`,
  visibleColumnsAria: `Lista de colunas visíveis`,
  visibleColumnsList: `Colunas visíveis`,
};
